import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Components from "./views/Components.vue";
import Main from "./views/Main.vue";
import Landing from "./views/Landing.vue";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
import ResetPw from "./views/ResetPw.vue";
import Account from "./views/Account.vue";
import BuyXrp from "./views/BuyXRP.vue";
import store from "./store/store"

const beforeAuth = isAuth => (from, to, next) => {
  const isAuthenticated = store.getters["isAuthenticated"]
  if ((isAuthenticated && isAuth) || (!isAuthenticated && !isAuth)) {
    return next()
  } else {
    // 로그인이 안되어 있다면, 홈 화면으로 이동
    alert("접근권한이 없습니다.");
    next("/login")
  }
}


Vue.use(Router);

export default new Router({
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/",
      alias: ['/logout'],
      name: "Main",
      components: {
        header: AppHeader,
        default: Main,
        footer: AppFooter
      }
    },
    /*
    // 2022.02.11 메인화면이 아니라 바로 가입화면으로 이동하도록 한다.
    {
      path: "/refer/:sharekey",
      //alias: ['/', '/logout'],
      name: "Main_with_sharekey",
      props: true,
      components: {
        header: AppHeader,
        default: Main,
        footer: AppFooter
      }
    },*/
    {
      path: "/refer/:sharekey/:centercode",
      //alias: ['/register'],
      name: "Main_with_sharekey",
      props: true,
      components: {
        header: AppHeader,
        default: Register,
        footer: AppFooter
      }
    },
    {
      path: "/landing",
      name: "landing",
      components: {
        header: AppHeader,
        default: Landing,
        footer: AppFooter
      }
    },
    {
      path: "/login",
      name: "login",
      components: {
        header: AppHeader,
        default: Login,
        footer: AppFooter
      }
    },
    {
      path: "/register",
      name: "register",
      components: {
        header: AppHeader,
        default: Register,
        footer: AppFooter
      }
    },
    {
      path: "/reset-pw",
      name: "reset-pw",
      components: {
        header: AppHeader,
        default: ResetPw,
        footer: AppFooter
      }
    },
    {
      path: "/account",
      name: "account",
      components: {
        header: AppHeader,
        default: Account,
        footer: AppFooter
      },
      beforeEnter: beforeAuth(true),
      /*
      meta: {
        authRequired: true  // 요 화면에 접근하기 위해선 인증이 필요하다..!!
      },*/
    },
    {
      path: "/buy-xrp",
      name: "buy-xrp",
      components: {
        default: BuyXrp,
      },
      beforeEnter: beforeAuth(true),
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
